/**
 * For use when validating trips
 */
export class SetErrorBlock {

    setID: string = '';

    isError: Boolean = true;

    title: string = '';

    errorItems: string[] = [];

    //Index into the static list of sets
    setIndex: number = 0;

    constructor(title: string, items: string[], index: number, id: string, isError = true) {
        this.title = title;
        this.errorItems = items;
        this.setIndex = index;
        this.setID = id;
        this.isError = isError;
    }
}